import React, { useState, useEffect } from "react";
import { useParams } from "react-router";

import dateFormat from "dateformat";
import TvShowsSeasons from "./TvShows.season";

import Api from "../../Api/Api";
import { username } from "../../API";

const MovieView = () => {
  const [show, setShow] = useState(null);
  const { showid } = useParams();
  useEffect(() => {
    const getData = async () => {
      let data = await Api.getTvShowInfo(username, showid);
      if(data&&data.season?.length){
        data.season=data.season.sort((a,b) =>a.number-b.number)
      }
      console.log("daattaaaaaaaaa",data);
      setShow(data);
    };
    getData();
  }, [showid, username]);

  return (
    <>
      {(showid === undefined || username === undefined) && (
        <h2 className="movie-name">NoT valid Tv Show</h2>
      )}
      {show && (
        <div>
          <img
            src={`${show.bannerimage ? show.bannerimage : show.thumbnail}`}
            alt={`${show.title} `}
            style={{ maxHeight: "80vh", position: "relative" }}
            width="100%"
          />
          <div className="container mt-5">
            <div className="d-flex flex-wrap justify-content-between">
              <div className="d-inline-flex flex-wrap align-items-center text-light">
                <h1>{show && show.title}</h1>
                <p className="mt-3">
                  {" "}
                  &nbsp;&nbsp;
                  {show.Languages.length !== 0 && ` (${show.Languages})`}
                </p>
              </div>
            </div>
            <div className="d-inline-flex flex-wrap text-light">
              <div className="d-inline-flex flex-wrap">
                <img
                  className="rounded"
                  src="/assets/images/icons/logo-imdb.png"
                  alt="IMDB"
                  height="35px"
                />
                &nbsp;&nbsp;
                <span className="movie-length mt-1 ms-1 me-1">
                  {show.genres.length !== 0 && (
                    <span className="mt-1 ms-1 me-1 text-muted">
                      |{show.genres}
                    </span>
                  )}
                </span>
                <span className="mt-1 text-muted ms-1 me-1">|</span>{" "}
                <span className="movie-length mt-1 ms-1 me-1">
                  {show && dateFormat(show.date, "dddd  mmmm  yyyy")}
                </span>
              </div>
            </div>
          </div>
          {show.season.map((season, index) => {
            return (
              <TvShowsSeasons
                season={season}
                thumbnail={show.thumbnail}
                languages={show.Languages}
                key={index}
                title={show.title}
              />
            );
          })}
        </div>
      )}
    </>
  );
};
export default MovieView;
